import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-accordion-item',
    template: `
        <div class="accordion-head" (click)="onClick($event)">
            <ng-content *ngIf="!active" select="[head]"></ng-content>
            <ng-content *ngIf="active" select="[head-active]"></ng-content>
        </div>
        <div class="accordion-body" [class.active]="active">
            <ng-content select="[body]"></ng-content>
        </div>
    `,
    styles: [`
        .accordion-head {
            cursor: pointer;
        }

        .accordion-body {
            display: none;
            max-height: 0;
        }

        .accordion-body.active {
            display: block;
            max-height: 1000px;
            -webkit-animation: fadeIn 1s;
            animation: fadeIn 1s;
        }

        @-webkit-keyframes fadeIn {
            from {
                opacity: 0;
                max-height: 0;
            }
            to {
                opacity: 1;
                max-height: 1000px;
            }
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                max-height: 0;
            }
            to {
                opacity: 1;
                max-height: 1000px;
            }
        }
    `]
})
export class AccordionItemComponent {

    @Input()
        active = false;

    @Output()
        activeChange: EventEmitter<boolean> = new EventEmitter();

    onClick(event: { preventDefault: () => void }): void {
        event.preventDefault();
        this.activeChange.emit(this.active);
    }

}
